import React from 'react'
import Pt from 'prop-types'
import { connect } from 'react-redux'
import { PageHeader } from 'react-bootstrap'

import {
  OfferFilterRecord,
  SignupWithExternalsRecord,
} from 'internal-components/src/records'
import { makeSelectLoading } from 'internal-components/src/redux/modules/loading'

import PageLoading from '../../components/Layout/PageLoading'

import createSignupProgress, {
  SignupProgressRecord,
} from '../../records/SignupProgress'
import { selectEditSignupWithExternals } from '../../redux/modules/signupEdit/selectors'
import OfferSelector from '../../components/OfferSelector'
import ProgressSummary from '../../components/Signup/ProgressSummary'
import * as signupActions from '../../redux/modules/signupEdit/actions'

export class OfferView extends React.Component {
  componentWillMount() {
    this.props.updateFilter('allowCalix', false);
  }

  render() {
    const {
      advanceToAccount,
      filter,
      loading = false,
      selectOffer,
      signupProgress,
      signupWithExternals,
      updateFilter,
    } = this.props;
    return (
      <section className="container">
        <PageHeader>Select a Service and Plan</PageHeader>

        <ProgressSummary
          signupProgress={signupProgress}
          signupWithExternals={signupWithExternals}
        />

        {loading && <PageLoading/>}

        {!loading && (
          <OfferSelector
            addressSupplied={!!signupWithExternals.signup.address}
            currentOffer={signupWithExternals.offer}
            currentOfferId={signupWithExternals.signup.offer}
            filter={filter}
            onSelect={advanceToAccount}
            selectOffer={selectOffer}
            updateFilter={updateFilter}
          />
        )}
      </section>
    )
  }
}

OfferView.propTypes = {
  advanceToAccount: Pt.func.isRequired,
  filter: Pt.instanceOf(OfferFilterRecord).isRequired,
  loading: Pt.bool,
  selectOffer: Pt.func.isRequired,
  signupProgress: Pt.instanceOf(SignupProgressRecord).isRequired,
  signupWithExternals: Pt.instanceOf(SignupWithExternalsRecord),
  updateFilter: Pt.func.isRequired,
}

const mapStateToProps = () => {
  const selectLoading = makeSelectLoading()

  return state => {
    const signupWithExternals = selectEditSignupWithExternals(state, {
      sortBy: null,
    })

    return {
      filter: state.signupEdit.getIn(['meta', 'filter']),
      loading: selectLoading(state, { type: ['products', 'offers'] }),
      signupProgress: createSignupProgress(
        signupWithExternals,
        state.signupEdit.get('errors'),
        'offer',
      ),
      signupWithExternals,
    }
  }
}

export default connect(
  mapStateToProps,
  signupActions,
)(OfferView)



// WEBPACK FOOTER //
// ./src/views/SignupForm/OfferView.jsx